import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Banner, DataTable, Text } from '@dixa/lib-shared-habla';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { analytics } from 'app/utils/segment';
import { createSearchUrl } from 'app/views/layout/views/search/utils';
import { useConversations } from 'hooks/useConversations/useConversations';
import styles from '../../userDetails.module.scss';
import { makeColumns } from '../../utils/makeColumns';
const conversationsLoading = (_jsx(Text.Paragraph, { children: "Loading assigned conversations..." }));
const conversationsFailed = (_jsx(Banner, { variant: "fail", icon: null, description: _jsx(Text.Paragraph, { children: "An error occurred while loading assigned conversations" }) }));
const conversationsEmpty = (_jsx(Banner, { variant: "info", icon: null, description: _jsx(Text.Paragraph, { children: "There are no previous assigned conversations" }) }));
export function UserAssignedConversations({ user, }) {
    const { items, asyncStatus, hasNextPage, hasPreviousPage, nextPage, previousPage, changeParams, } = useConversations({
        agent: user.id,
        page_size: 6,
    });
    useEffect(() => {
        changeParams({
            agent: user.id,
            page_size: 6,
        });
    }, [user.id, changeParams]);
    if (asyncStatus === 'failed') {
        return conversationsFailed;
    }
    if (!items.length) {
        if (asyncStatus === 'loading') {
            return conversationsLoading;
        }
        return conversationsEmpty;
    }
    return (_jsxs(_Fragment, { children: [_jsx(DataTable, { data: items, columns: makeColumns(({ requester }) => requester, 'Contact'), paginationProps: {
                    loading: asyncStatus === 'loading',
                    previousButtonDisabled: !hasPreviousPage,
                    nextButtonDisabled: !hasNextPage,
                    previousButtonClick: previousPage,
                    nextButtonClick: nextPage,
                } }), _jsx("div", Object.assign({ className: styles.seeAllLinkContainer }, { children: _jsx(Link, Object.assign({ to: createSearchUrl('conversations', {
                        query: '',
                        filters: {
                            strategy: 'all',
                            conditions: [
                                {
                                    field: 'agent_id',
                                    operator: 'is_one',
                                    values: [{ label: '', value: user.id }],
                                },
                            ],
                        },
                    }), onClick: () => analytics.contactsCardSeeAllAssignedConversationsClicked() }, { children: "See all assigned conversations" })) }))] }));
}
